import { useState, useCallback } from 'react'
import { DashboardClient } from '../../../client/DashboardClient'
import { DashboardData, DashboardAsset } from '../../../types/Dashboard'
import { AsyncComponentP } from '../../common/AsyncComponent'
import { DashboardView } from './DashboardView'

type DashboardPageProps = {
    dashboardClient: DashboardClient
}

export function DashboardPage({ dashboardClient }: DashboardPageProps) {
    return (
        <AsyncComponentP
            loaderFunction={() => dashboardClient.retrieveDashboardData()}
            dataPropName="dashboardData"
        >
            <DashboardContainer dashboardData={null as unknown as DashboardData} />
        </AsyncComponentP>
    )
}

type DashboardContainerProps = {
    dashboardData: DashboardData
}

function DashboardContainer({ dashboardData }: DashboardContainerProps) {
    const [selectedAsset, setSelectedAsset] = useState<DashboardAsset | null>(null)

    const selectAsset = useCallback((id: number) => {
        const asset = dashboardData.assets.find(a => a.id === id) ?? null
        setSelectedAsset(asset)
    }, [dashboardData.assets])

    const clearSelection = useCallback(() => {
        setSelectedAsset(null)
    }, [])

    return (
        <DashboardView
            assets={dashboardData.assets}
            metrics={dashboardData.metrics}
            selectedAsset={selectedAsset}
            onSelectAsset={selectAsset}
            onClearSelection={clearSelection}
        />
    )
}
